var css = {"tagMarginTop":"ButtonSelector-module_tagMarginTop__qiqgn"};

export { css as default };
